import styled from 'styled-components';

export const Wrapper = styled.div`
  .single-col {
    display: grid;
    grid-template-columns: 1fr;
  }

  .go-back {
    margin: 0 !important;
    position: absolute;
    cursor: pointer;
  }
`;

export const Content = styled.div`
  width: 85%;
  margin: 40px auto;
`;

export const StyledSectionHeader = styled.h3`
  color: white;
  margin: 5px;
  margin-bottom: 23px;
`;

export const ContentRowSingleCol = styled.div`
  margin: 40px 0 65px;

  }

  h1 {
    text-align: center;
    font-size: 30px;
    font-weight: 900;
    color: white;
    margin: 0;

    span {
      color: #ff0033;
    }
  }

  h5 {
    color: lightskyblue;
    text-align: center;
    font-size: 26px;
    margin-top: 15px;
  }
`;


export const ContentRow = styled.div`
  display: grid;
  grid-template-columns: 2fr 3fr;
  margin: 40px 0 65px;
  grid-column-gap: 4%;

  }

  h1 {
    text-align: center;
    font-size: 30px;
    font-weight: 900;
    color: white;
    margin: 0;

    span {
      color: #ff0033;
    }
  }

  h5 {
    color: lightskyblue;
    text-align: center;
    font-size: 26px;
    margin-top: 15px;
  }
`;

export const ContentCol = styled.div`
  display: grid;
  grid-row-gap: 40px;

  p {
    margin: 0 35px 0 0;
    font-size: 18px;
    font-weight: 700;
    color: white;
  }
`;

export const ModalWrapper = styled.div`
  margin-top: 180px;

  p {
    margin: 0 35px 0 0;
    font-size: 18px;
    font-weight: 700;
    color: white;
  }
`;





// WEBPACK FOOTER //
// ./src/pages/Admin/Courses/SingleCourse/SingleCourse.styles.ts